import { useLocation, Link } from "react-router-dom";

const ContactInquiryDetail = () => {
  const location = useLocation();
  const data = location.state;

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5">
        <h3 className="page-title">View Inquiry</h3>
      </div>

      <div className="row grid-margin stretch-card">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form>
                <div className="row g-3">
                  <div className="col-lg-6 col-md-12">
                    <label className="col-form-label">Name</label>
                    <input
                      type="text"
                      className="form-control form-control-sm border border-dark"
                      value={data?.name || ""}
                      disabled
                    />
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <label className="col-form-label">Email</label>
                    <input
                      type="text"
                      className="form-control form-control-sm border border-dark"
                      value={data?.email || ""}
                      disabled
                    />
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <label className="col-form-label">Mobile Number</label>
                    <input
                      type="text"
                      className="form-control form-control-sm border border-dark"
                      value={data?.mobile_number || ""}
                      disabled
                    />
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <label className="col-form-label">Subject</label>
                    <input
                      type="text"
                      className="form-control form-control-sm border border-dark"
                      value={data?.subject || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="col-form-label">Message</label>
                    <textarea
                      className="form-control border border-dark"
                      rows="5"
                      value={data?.message || ""}
                      disabled
                    />
                  </div>
                  <div className="col-12 mt-4 text-center">
                    <Link to="/contact">
                      <button type="button" className="btn btn-danger">
                        Back
                      </button>
                    </Link>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInquiryDetail;